var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Insights',{attrs:{"module-class":"profile-insight","roleIdProp":_vm.roleIdProp,"citiesString":_vm.citiesString,"insights-api-url":"/api/profile/insights","prompts-api-url":"/api/profile/prompts"}})}
var staticRenderFns = []

export { render, staticRenderFns }